import React, { useEffect, useState } from 'react'
import { addressIsEmpty } from 'lib/core/resources/helpers'
import {
  useCheckout,
  useCheckoutContext,
  AddressCard,
  BillingAddressForm as Form,
  useSameAsShipping,
  UseShippingAddress
} from 'lib/modules/checkout'

export const BillingAddress = () => {
  const { setState } = useCheckoutContext()
  const { requiresShipping, checkoutSchema, billingAddress, setBillingAddressSameAsShipping } = useCheckout()
  const { setUseSameAsShipping } = useSameAsShipping()
  const billingAddressIsEmpty = addressIsEmpty(checkoutSchema?.billingAddress)
  const billingAddressIsSuccess = !billingAddress.isFetching && billingAddress.isSuccess
  const [isFormVisible, setIsFormVisible] = useState(false)
  const needsShipping = requiresShipping()
  const renderAddressCard = !isFormVisible

  useEffect(() => {
    if (billingAddressIsEmpty) {
      setUseSameAsShipping(true)
    }
    // eslint-disable-next-line
  }, [
    billingAddressIsEmpty
  ])

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        isBillingAddressUpdated: true
      }
    })
  }, [setState])

  useEffect(() => {
    if (billingAddressIsSuccess) {
      setState((state) => {
        return {
          ...state,
          isBillingAddressUpdated: true
        }
      })
    }
  }, [
    setState,
    billingAddressIsSuccess
  ])

  const handleForm = (visible: boolean, scrollTop: boolean) => {
    if (scrollTop) {
      window.scrollTo(0, 0)
    }
    setIsFormVisible(visible)
  }

  return (
    <>
      {needsShipping && (
        <UseShippingAddress
          onChange={(value) => {
            handleForm(!value, value)
            if (value) {
              setState((state) => {
                return {
                  ...state,
                  isBillingAddressUpdated: true
                }
              })
            }
          }}
        />
      )}

      {renderAddressCard && (
        <AddressCard
          isLoading={billingAddress.isFetching}
          onEdit={() => {
            if (!billingAddress.isFetching) {
              handleForm(true, true)
            }
            setBillingAddressSameAsShipping({ value: false })
          }}
        />
      )}

      {isFormVisible && (
        <Form
          onSubmit={() => handleForm(false, true)}
          onCancel={() => handleForm(false, true)}
        />
      )}
    </>
  )
}
